import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import {
  MagnifyingGlassIcon,
  SparklesIcon,
  QuestionMarkCircleIcon,
  WalletIcon,
  PuzzlePieceIcon,
  ChevronDownIcon,
  Bars4Icon,
  EllipsisHorizontalIcon,
  ChevronLeftIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';

interface ListRecord {
  id: string;
  name: string;
  recordsCount: string;
  createdBy: string;
  createdDate: string;
  lastUpdated: string;
  hasActions: boolean;
}

const tableData: ListRecord[] = [
  {
    id: '1',
    name: 'All saved people',
    recordsCount: '-',
    createdBy: '-',
    createdDate: '-',
    lastUpdated: '-',
    hasActions: false,
  },
  {
    id: '2',
    name: 'test',
    recordsCount: '1 people',
    createdBy: 'John Doe (you)',
    createdDate: '21 March 2026',
    lastUpdated: '21 March 2026',
    hasActions: true,
  },
];

export default function ListsDashboard() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
        <div className="flex items-center gap-8 w-full max-w-4xl">
          <h1 className="text-xl font-semibold text-gray-800">Lists</h1>
          <div className="relative w-full max-w-2xl">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              type="text"
              className="block w-full rounded-md border border-gray-200 py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Search people or companies"
            />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button className="flex items-center gap-1.5 rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-100 transition-colors">
            <SparklesIcon className="h-4 w-4" />
            Upgrade
          </button>
          
          {/* <div className="h-6 w-px bg-gray-200" aria-hidden="true" /> */}
          
          {/* <div className="flex items-center gap-3 text-gray-500">
            <button className="hover:text-gray-700"><QuestionMarkCircleIcon className="h-6 w-6" /></button>
            <button className="hover:text-gray-700"><PuzzlePieceIcon className="h-6 w-6" /></button>
            <button className="hover:text-gray-700"><WalletIcon className="h-6 w-6" /></button>
          </div> */}

          {/* <Menu as="div" className="relative ml-2">
            <Menu.Button className="flex items-center gap-1 focus:outline-none">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-100 text-sm font-semibold text-red-600">
                JD
              </div>
              <ChevronDownIcon className="h-4 w-4 text-gray-500" />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <Menu.Item>
                  {({ active }) => (
                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active ? 'bg-gray-100' : ''}`}>Profile</a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active ? 'bg-gray-100' : ''}`}>Settings</a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active ? 'bg-gray-100' : ''}`}>Sign out</a>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu> */}
        </div>
      </header>

      <main className="mx-auto max-w-full p-6">
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between border-b border-gray-200 p-4">
            <div className="flex items-center gap-4">
              <div className="relative w-64">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
                </div>
                <input
                  type="text"
                  className="block w-full rounded-md border border-gray-200 py-1.5 pl-9 pr-3 text-sm placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Search for lists"
                />
              </div>

              <select className="block rounded-md border border-gray-200 py-1.5 pl-3 pr-8 text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 appearance-none bg-white">
                <option>Created by me</option>
                <option>Created by anyone</option>
              </select>

              <select className="block rounded-md border border-gray-200 py-1.5 pl-3 pr-8 text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 appearance-none bg-white">
                <option>People and companies</option>
                <option>People</option>
                <option>Companies</option>
              </select>
            </div>

            <button className="flex items-center gap-2 rounded-md bg-[#ff2b44] px-4 py-2 text-sm font-semibold text-white hover:bg-red-600 transition-colors">
              <Bars4Icon className="h-4 w-4" />
              Create list
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Name</th>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Records count</th>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Created by</th>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Created date</th>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Last updated</th>
                  <th scope="col" className="px-6 py-3 font-medium text-gray-500">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {tableData.map((row) => (
                  <tr key={row.id} className="hover:bg-gray-50/50">
                    <td className="px-6 py-4 font-medium text-gray-900 flex items-center gap-3">
                      <Bars4Icon className="h-5 w-5 text-gray-400" />
                      {row.name}
                    </td>
                    <td className="px-6 py-4 text-gray-500">{row.recordsCount}</td>
                    <td className="px-6 py-4 text-gray-500">{row.createdBy}</td>
                    <td className="px-6 py-4 text-gray-500">{row.createdDate}</td>
                    <td className="px-6 py-4 text-gray-500">{row.lastUpdated}</td>
                    <td className="px-6 py-4 text-gray-500">
                      {row.hasActions ? (
                        <Menu as="div" className="relative inline-block text-left">
                          <Menu.Button className="flex items-center justify-center rounded-md border border-gray-200 bg-white p-1 hover:bg-gray-50 focus:outline-none">
                            <EllipsisHorizontalIcon className="h-5 w-5 text-gray-500" />
                          </Menu.Button>
                          {/* <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                              <Menu.Item>
                                {({ active }) => (
                                  <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active ? 'bg-gray-100' : ''}`}>Edit</a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a href="#" className={`block px-4 py-2 text-sm text-red-600 ${active ? 'bg-gray-100' : ''}`}>Delete</a>
                                )}
                              </Menu.Item>
                            </Menu.Items>
                          </Transition> */}
                        </Menu>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between border-t border-gray-200 px-6 py-3">
            <span className="text-sm text-gray-500">1 - 1 of 1</span>
            
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <div className="flex items-center gap-1">
                <button className="p-1 text-gray-300 cursor-not-allowed">
                  <ChevronLeftIcon className="h-4 w-4" />
                </button>
                <button className="px-3 py-1 rounded bg-gray-100 text-gray-900 font-medium">
                  1
                </button>
                <button className="p-1 text-gray-300 cursor-not-allowed">
                  <ChevronRightIcon className="h-4 w-4" />
                </button>
              </div>
              
              <div className="flex items-center gap-2">
                <span>Go to page</span>
                <input 
                  type="text" 
                  defaultValue="1" 
                  className="w-12 rounded-md border border-gray-200 py-1 text-center text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}